import React from "react";
import {
  Card,
  CardActions,
  Typography,
  IconButton,
  withStyles,
  withTheme,
} from "@material-ui/core";
import CancelIcon from "@material-ui/icons/Cancel";
import { withSnackbar } from "notistack";
import { compose } from "recompose";

const styles = (theme) => ({
  card: {
    maxWidth: 400,
    minWidth: 250
  },
  actionRoot: {
    padding: "8px 8px 8px 16px",
    backgroundColor: theme.snackbarSuccessBG
  },
  icons: {
    marginLeft: "auto"
  },
  typography: {
    color: theme.snackbarSuccessTextColor,
    paddingLeft: "4px",
    fontWeight: 600
  },
  closeIcon: {
    color: theme.snackBarCloseIcon,
  }
});
const CustomSnackbarRenderer = props => {
  const handleDismiss = () => {
    props.closeSnackbar(props.id);
  };
  const { classes } = props;
  return (
    <Card className={classes.card}>
      <CardActions classes={{ root: classes.actionRoot }} className={props.theme.themeName}>
        {props.animation}
        <Typography variant="subtitle2" className={classes.typography}>
          {props.snackbarLabel}
        </Typography>
        <div className={classes.icons}>
          <IconButton
            aria-label="cancel"
            onClick={handleDismiss}
            className={classes.closeIcon}
          >
            <CancelIcon />
          </IconButton>
        </div>
      </CardActions>
    </Card>
  );
};

export default compose(
  withStyles(styles),
  withSnackbar,
  withTheme(),
)(CustomSnackbarRenderer);
